<template>
  <div>
    <el-card sharow>
      <el-form :model="searchForm" ref="searchForm" size="small" label-width="100px" inline>
        <el-form-item label="活动名称" prop="name">
          <el-input v-model.trim="searchForm.name" placeholder="产品名称" />
        </el-form-item>
        <el-form-item label=" " label-width="100px">
          <el-button type="primary" @click="search('searchForm')">查询</el-button>
          <el-button @click="reset('searchForm')">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <br>
    <el-table border stripe v-loading="loading" :data="tableData" style="width: 100%">
      <el-table-column prop="name" label="活动名称" minWidth="100" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="startDate" label="活动起止时间" minWidth="250" align="center">
        <template slot-scope="scope">
          <template v-if="scope.row.startDate">{{scope.row.startDate}} -- {{scope.row.endDate}}</template>
          <template v-else>--</template>
        </template>
      </el-table-column>
      <el-table-column prop="registerNum" label="新用户注册数" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="pvNum" label="活动PV" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="uvNum" label="活动uv" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="invitationNum" label="邀请次数" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="joinNum" label="参团次数" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="initNum" label="发起拼团数" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="orderNum" label="成单数" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
      <el-table-column prop="pay" label="成单金额" minWidth="160" align="center" :formatter="fliteRData"></el-table-column>
    </el-table>
    <br>
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="pageSizes" layout="total, sizes, prev, pager, next" :total="total" />
  </div>
</template>

<script>
import tableMoudel from "@/libs/mixin/table";

import { data } from "./api"

export default {
  mixins: [tableMoudel],
  data () {
    return {
      searchForm: {
        name: ""
      }
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      const params = { ...this.pageInfo, ...this.searchForm }
      const res = await data.getDataListPage(params)
      if (res.code !== 0) return
      const { records } = res.data
      this.total = Number(res.data.total)
      this.tableData = records.map(item => {
        return {
          ...item.activitySpRecord,
          ...item
        }
      })
    },
  }
}
</script>

<style>
</style>